import type MP4Box from 'mp4box';

const isVariableFrameRateMode = (mp4BoxFile: MP4Box.MP4File, info: MP4Box.Mp4BoxInfo): boolean => {
  let initialTimeScaleRatio: number | undefined;

  for (const track of info.videoTracks) {
    const samples: MP4Box.TrackSample[] = mp4BoxFile.getTrackSamplesInfo(track.id);

    if (!samples.length) {
      return false;
    }

    if (initialTimeScaleRatio === undefined) {
      const { duration, timescale } = samples[0];
      initialTimeScaleRatio = timescale / duration;
    }

    const isConstantFrameRate = samples.every((sample) => {
      const sampleRatio = sample.timescale / sample.duration;
      const isConstant = sampleRatio === initialTimeScaleRatio;

      if (!isConstant) {
        console.log(
          `Constant frame rate preferred, but variable frame rate detected. Initial frame rate: ${initialTimeScaleRatio} and found second frame rate ${sampleRatio}`
        );
        return false;
      }
      return true;
    });

    if (!isConstantFrameRate) {
      return true;
    }
  }
  return false;
};

export default isVariableFrameRateMode;
